export default "__VITE_ASSET__DYcmgC1e__"